import { LoginService } from './../../../core/services/login.service';
import { Apollo, gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import { combineLatest } from 'rxjs';
import { Filter } from 'src/app/core/models/filter';
import { pluck } from 'rxjs/operators';

const supplyEnquiriesSubscription = gql`query supply_enquiries( $sort: [supply_enquiries_order_by!], $userId: uuid,$search: String, $limit: Int, $offset: Int) {
  supply_enquiries(where: {
    _or:[{
      dental_supplier_id: {_eq: $userId}
    },{
      dental_practice_id: {_eq: $userId}
    },{
      dental_professional_id: {_eq: $userId}
    }],
    supply: {name: {_ilike: $search }}
  },
    order_by:$sort,
    limit: $limit, offset: $offset) {
    id
    created_at
    updated_at
    supply_id
    supply {
      id
      name
      image
    }
    supply_variant_id
    supply_variant{
      id
      title
      image
    }
    message
    attachments
    type
    dental_supplier_id
    dental_supplier{
      id
      name
      email
      phone
    }
    dental_professional_id
    dental_professional {
      id
      name
      email
      phone
    }
    dental_practice_id
    dental_practice {
      id
      name
      email
      phone
    }
  }
}`;

const supplyEnquiriesAggregateSubscription = gql`query supply_enquiries_aggregate ($userId: uuid, $search: String, $status: String){
  supply_enquiries_aggregate(where:{
    _or:[{
      dental_supplier_id: {_eq: $userId}
    },{
      dental_practice_id: {_eq: $userId}
    },{
      dental_professional_id: {_eq: $userId}
    }],
    message: {_ilike: $search}}) {
    aggregate {
      count
    }
  }
}`;


@Injectable({
  providedIn: 'root'
})
export class GetSupplyEnquiriesService {

  constructor(private apollo: Apollo, private loginService: LoginService) { }

  getSupplyEnquiries(filter: Filter){
    const loginData = this.loginService.getLoginData();
    return combineLatest([
      this.apollo.use('external').query({
       query: supplyEnquiriesSubscription,
       fetchPolicy: "network-only",
       variables: {
         userId: loginData.id,
         search: `%${filter.search}%`,
         sort: filter.sort,
         limit: filter.limit,
         offset: filter.offset
       }
      }).pipe(pluck('data', 'supply_enquiries')),
      this.apollo.use('external').query({
        query: supplyEnquiriesAggregateSubscription,
        fetchPolicy: "network-only",
        variables: {
          userId: loginData.id,
          search: `%${filter.search}%`
        }
      }).pipe(pluck('data', 'supply_enquiries_aggregate', 'aggregate', 'count')),
    ]);
  }
}
